import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import ProductCommunityItemContainer from 'containers/ProductCommunityPostItem'
import loadCommunityPostsProductActions from 'modules/products/actions/load'
import { isDomainListLoadingDomainSelector } from 'modules/redux/selectors/domain'
import { MOTIVATION_DOMAIN } from 'modules/motivation/constants'
import { getAllCommunityPostsProductsSelector } from 'modules/products/selectors/get-all-community-posts'
import { getCommunityPostsProductsSelector } from 'modules/products/selectors/get-community-posts'
import { View } from 'components/View'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import TextTitleLight from 'components/TextTitleLight'

const COMMUNITY_POSTS_TYPE = {
  ALL: 1,
  PRODUCT: 2,
  GENDER: 3
}

class CommunityPostsComponent extends React.Component {
  componentDidMount () {
    this.loadData()
  }

  loadData (props = this.props) {
    props.dispatch(
      loadCommunityPostsProductActions(props.query)
    )
  }

  render () {
    const { communityPosts } = this.props
    if (!communityPosts.length) {
      return <></>
    }
    return (
      <View>
        <TextTitleLight>
          Join the #gymaholic community
        </TextTitleLight>
        <View
          style={{
            flexDirection: View.DIRECTION.ROW,
            overflowX: 'scroll',
            WebkitOverflowScrolling: 'touch',
            marginTop: STYLES_MARGIN.SMALL
          }}
        >
          {
            this.props.communityPosts.map((instance, index) =>
              (
                <div
                  key={index}
                  style={{
                    marginLeft: !index
                      ? undefined
                      : STYLES_MARGIN.SMALL

                  }}
                >
                  <ProductCommunityItemContainer
                    key={index}
                    instance={instance}
                  />
                </div>
              )
            )
          }
        </View>
      </View>
    )
  }
}

CommunityPostsComponent.defaultProps = {
  type: COMMUNITY_POSTS_TYPE.ALL,
  query: 'iamagymaholic'
}

CommunityPostsComponent.propTypes = {
  communityPosts: PropTypes.arrayOf(
    PropTypes.object
  )
}

const select = () => createSelector(
  (state, props) => {
    if (props.type === COMMUNITY_POSTS_TYPE.PRODUCT) {
      return getCommunityPostsProductsSelector()(state, props)
    }
    return getAllCommunityPostsProductsSelector()(state, props)
  },
  isDomainListLoadingDomainSelector(MOTIVATION_DOMAIN),
  (
    communityPosts,
    isLoading
  ) => ({
    communityPosts,
    isLoading
  })
)

const CommunityPosts = connect(select)(CommunityPostsComponent)

CommunityPosts.TYPE = COMMUNITY_POSTS_TYPE

export default CommunityPosts
